
export enum FastTrackModalMode {
  ADD_CLIENT,
  FTF
}
